import Sticker from './main.vue';

export default Sticker;
